import { useMutation } from '@tanstack/react-query';
import { fetchPostApiAdminTriggersPackages, } from '../../generated/sitComponents';
import { useSitContext } from '../../generated/sitContext';
export function usePostAdminTriggersPackages(options) {
    const { fetcherOptions } = useSitContext();
    return useMutation({
        mutationFn: async (variables) => {
            return await fetchPostApiAdminTriggersPackages({
                ...fetcherOptions,
                ...variables,
                headers: {
                    ...fetcherOptions.headers,
                },
            });
        },
        ...options,
    });
}
//# sourceMappingURL=use-post-admin-triggers-packages.js.map